import { ApiResponse } from '@core/interface/api-response.interface';
import { RefId } from '@core/interface/ref-id.interface';
import { Observable } from 'rxjs';
import { CreateManagementReportAccountingExecutionRequestDto } from '../dtos/create-management-report-accounting-execution.request.dto';
import { DispatchErpManagementReportAccountingExecutionRequestDto } from '../dtos/dispatch-erp-management-report-accounting-execution.request.dto';
import { DispatchErpManagementReportAccountingExecutionResponseDto } from '../dtos/dispatch-erp-management-report-accounting-execution.response.dto';
import { ManagementReportAccountingExecutionResponseDto } from '../dtos/management-report-accounting-execution.response.dto';
import { PreviewManagementReportAccountingExecutionResponseDto } from '../dtos/preview-management-report-accounting-execution.response.dto';

export abstract class ManagementReportAccountingExecutionRepository {
  abstract create(
    request: CreateManagementReportAccountingExecutionRequestDto,
  ): Observable<ApiResponse<ManagementReportAccountingExecutionResponseDto>>;

  abstract show(
    request: RefId,
  ): Observable<ApiResponse<ManagementReportAccountingExecutionResponseDto>>;

  abstract download(
    request: RefId,
  ): Observable<ApiResponse<{ viewUrl: string }>>;

  abstract preview(
    request: RefId,
  ): Observable<
    ApiResponse<PreviewManagementReportAccountingExecutionResponseDto>
  >;

  abstract delete(request: RefId): Observable<ApiResponse<void>>;

  abstract dispatchErp(
    request: DispatchErpManagementReportAccountingExecutionRequestDto,
  ): Observable<
    ApiResponse<DispatchErpManagementReportAccountingExecutionResponseDto>
  >;
}
